import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_SAMPLE_COLLECTORS } from "../../config/connString";
import useAxios from "../../utils/useAxios";

const deleteSampleCollector = createAsyncThunk(
  "sample-collectors/delete-sample-collectors",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.delete(URL_SAMPLE_COLLECTORS + "/" + data);
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { deleteSampleCollector };
